export const getProductInfoText = (title?: string, description?: string) => {
    if (title && description) {
        return `${title} – ${description}`
    }

    if (title && !description) {
        return title
    }

    if (description) {
        return description
    }
    return ''
}
